import './MachineCloudOnboarding.css';

import React, { type FC, useEffect } from 'react';
import { useWifiNetworks, useRemoteAccess } from '@src/contexts';

interface MachineCloudOnboardingProps {
  onComplete: () => void
  onCancel: () => void
}

export const MachineCloudOnboarding: FC<MachineCloudOnboardingProps> = ({ onComplete, onCancel }) => {
  const { connectedWifiNetwork, requestNetworkPolling } = useWifiNetworks();
  const isWifiConnected = Boolean(connectedWifiNetwork);
  const { requestRemoteAccess } = useRemoteAccess();

  useEffect(() => {
    return requestNetworkPolling();
  }, []);

  const completeMachineCloudOnboarding = (shouldEnableRemote: boolean): void => {
    if (shouldEnableRemote) { requestRemoteAccess(true); }
    onComplete();
  };

  const syncMessage = isWifiConnected
    ? 'MachineCloud Sync Successful'
    : 'MachineCloud Sync Unsuccessful';

  const syncIcon = isWifiConnected
    ? <img alt={syncMessage} src="../images/sync-ok.png" />
    : <img alt={syncMessage} src="../images/sync-not.png" />;

  const syncInstructions = isWifiConnected
    ? 'Enable remote access to continue deployment, then return to your laptop'
    : 'Connect WiFi to complete sync.';

  const actionButton = isWifiConnected
    ? <ActionButton text="Enable Access" onClick={() => { completeMachineCloudOnboarding(true); }} />
    : <ActionButton text="Connect WiFi" onClick={onCancel} />;

  return (
    <div id="machine_cloud_onboarding">
      <i id="machine_cloud_onboarding_skip_button" className="fal fa-times" onClick={() => { completeMachineCloudOnboarding(false); }} />
      <div id="machine_cloud_onboarding_sync_icon">{syncIcon}</div>
      <div id="machine_cloud_onboarding_sync_message" className={isWifiConnected ? 'secondary_green' : 'yellow_secondary'}>{syncMessage}</div>
      <div id="machine_cloud_onboarding_sync_instructions">{syncInstructions}</div>
      {actionButton}
    </div>
  );
};

interface ActionButtonProps {
  text: string
  onClick: () => void
}

const ActionButton: FC<ActionButtonProps> = ({ text, onClick }) => {
  return (
    <button
      id="machine_cloud_onboarding_connect_wifi_button"
      onClick={onClick}
      className="blue-button"
    >
      {text}
    </button>
  );
};
